import { tryParseJSON } from "@eventr/common";
import { Stack } from "@mui/material";
import { useMemo } from "react";
import { cardTranslation } from "i18n/translateHelpers";
import { CardText } from "../subComponents/cardText";
import { RowInfoFiles } from "../subComponents/rowInfoFiles";
import { RowInfoNotes } from "../subComponents/rowInfoNotes";
import { RowInfoWeb } from "../subComponents/rowInfoWeb";
interface FlightAttachmentsProps {
  extra_docs?: string;
  notes?: string;
  website?: string;
}

export const FlightAttachments = ({ extra_docs, notes, website }: FlightAttachmentsProps) => {
  const files = useMemo(() => {
    if (!extra_docs) return [];
    return tryParseJSON(extra_docs, []) as string[];
  }, [extra_docs]);

  if (!files.length && !notes && !website) return null;
  return (
    <Stack spacing="8px">
      <CardText variant="bodyBold">{cardTranslation("Attachments")}</CardText>
      {website && <RowInfoWeb website={website} />}
      {notes && <RowInfoNotes notes={notes} />}
      {files && <RowInfoFiles files={files} />}
    </Stack>
  );
};
